import { Component } from '@angular/core';
import {ButtonPadraoComponent} from "../../shared/components/button-padrao/button-padrao.component";

@Component({
  selector: 'app-balao-usuario-ad',
  standalone: true,
    imports: [
        ButtonPadraoComponent
    ],
  templateUrl: './balao-usuario-ad.component.html',
  styleUrl: './balao-usuario-ad.component.css'
})
export class BalaoUsuarioAdComponent {

}
